import React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { format, subMonths, startOfMonth, parse } from 'date-fns';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

const generateMonthOptions = () => {
  const months = [];
  const now = startOfMonth(new Date());

  // Go back 24 months to always cover the previous financial year (April start)
  for (let i = 0; i <= 24; i++) {
    const date = subMonths(now, i);
    months.push({
      label: format(date, 'MMMM yyyy'),
      value: format(date, 'dd/MM/yyyy'),
    });
  }

  return months;
};

interface TimesheetRangeSelectProps {
  onValueChange: (value: Date) => void;
  selectedDate: Date;
}

export default function TimesheetRangeSelect({ onValueChange, selectedDate }: TimesheetRangeSelectProps) {
  const insets = useSafeAreaInsets();
  const contentInsets = {
    top: insets.top,
    bottom: insets.bottom,
    left: 12,
    right: 12,
  };

  const monthOptions = generateMonthOptions();
  const selectedOption = monthOptions.find(
    option => option.value === format(selectedDate, 'dd/MM/yyyy')
  );

  const handleValueChange = (value: string) => {
    const parsedDate = parse(value, 'dd/MM/yyyy', new Date());
    onValueChange(parsedDate);
  };

  return (
    <Select
      value={selectedOption || monthOptions[0]}
      onValueChange={(option) => handleValueChange(option?.value || '')}
    >
      <SelectTrigger className='w-[250px]'>
        <SelectValue
          className='text-foreground text-sm native:text-lg'
          placeholder='Select a month'
        />
      </SelectTrigger>
      <SelectContent
        insets={contentInsets}
        className='w-[250px] z-[1000] bg-white shadow-lg'
      >
        <SelectGroup>
          <SelectLabel>Months</SelectLabel>
          {monthOptions.map((month) => (
            <SelectItem key={month.value} label={month.label} value={month.value}>
              {month.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
